import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EditorLink from 'lowcode/components/EditorLink';
import styled from './index.module.scss';

type ImgsType = {
    [key: string]: string[];
};

const MoreIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <g clipPath="url(#clip0_619_116)">
                <path d="M14 26C20.6274 26 26 20.6274 26 14C26 7.37258 20.6274 2 14 2C7.37258 2 2 7.37258 2 14C2 20.6274 7.37258 26 14 26Z" fill="#3F68E0" />
                <path d="M9.625 14H18.375" stroke="white" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 9.625V18.375" stroke="white" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_619_116">
                    <rect width="28" height="28" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default function SectionPhone() {
    const { locale } = getLocal();
    const { t } = useLang('delta_pro_ultra.launch.detail.OASIS');

    const imgsMap: ImgsType = {
        eu: [
            'https://websiteoss.ecoflow.com/upload/image/1751852036340/en_01.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188864527/en_02.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188864343/en_03.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188864159/en_04.png',
        ],
        de: [
            'https://websiteoss.ecoflow.com/upload/image/1751852036166/de_01.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188599676/de_02.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188599313/de_03.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188599493/de_04.png',
        ],
        fr: [
            'https://websiteoss.ecoflow.com/upload/image/1751852036745/fr_01.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188724072/fr_02.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188724259/fr_03.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188723882/fr_04.png',
        ],
        it: [
            'https://websiteoss.ecoflow.com/upload/image/1751852036956/it_01.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188763171/it_02.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188762787/it_03.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188762989/it_04.png',
        ],
        es: [
            'https://websiteoss.ecoflow.com/upload/image/1751852036594/es_01.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188831698/es_02.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188832064/es_03.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188831880/es_04.png',
        ],
        uk: [
            'https://websiteoss.ecoflow.com/upload/image/1751852037138/uk_01.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188796553/uk_02.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188796378/uk_03.png',
            'https://websiteoss.ecoflow.com/upload/image/1751188796725/uk_04.png',
        ],
    };

    const specialTitle = locale === 'us' ? t.rich('title', { sup: (text: any) => <sup>{text}</sup> }) : t('title');

    const imgs = imgsMap[locale] || imgsMap['eu'];

    return (
        <div className={styled.SectionPhone}>
            <EcoSectionCommon title={t('C_box4_title')} />
            <EcoSpaceSmall />
            <div className="content">
                <div className="item">
                    <EfImg pc={imgs[0]} />
                    <div className="text">{t('C_box4_text1')}</div>
                    <div className="desc">{t('C_box4_text1_desc')}</div>
                </div>
                <div className="item">
                    <EfImg pc={imgs[1]} />
                    <div className="text">{t('C_box4_text2')}</div>
                    <div className="desc">{t('C_box4_text2_desc')}</div>
                </div>
                <div className="item">
                    <EfImg pc={imgs[2]} />
                    <div className="text">{t('C_box4_text3')}</div>
                    <div className="desc">{t('C_box4_text3_desc')}</div>
                </div>
                <div className="item">
                    <EfImg pc={imgs[3]} />
                    <div className="text">{t('C_box4_text4')}</div>
                    <div className="desc">{t('C_box4_text4_desc')}</div>
                </div>
            </div>
            <div className="link-btn-container">
                <EditorLink
                    className="link-to-page"
                    href={`/${locale}/oasis-home-energy-management-system`}
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'activity_button',
                        page_name: 'EcoFlow DELTA Pro Ultra',
                        list_name: t('C_box4_title'),
                        button_name: t('C_box4_btn'),
                        function: 'Jump to OASIS page',
                    }}
                    target="_blank"
                >
                    <span>{t('C_box4_btn')}</span>
                    <MoreIcon />
                </EditorLink>
            </div>
        </div>
    );
}
